// extracted by mini-css-extract-plugin
export var cancelButton = "_ms-5";
export var content = "_ms-3";
export var createButton = "_ms-6";
export var drawerContainer = "_ms-0";
export var footer = "_ms-2";
export var header = "_ms-1";
export var orderFormColumn = "_ms-4";